import ActionsBuilder from '../../../../utils/actions/ActionsBuilder';

export const IDENTIFIER = '[SECTORS]';
export default {
  ...ActionsBuilder.buildList(IDENTIFIER)
};
